import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { StatoVideoperizia } from 'src/app/models/stato-videoperizia';
import { StatoVideoperiziaService } from 'src/app/services/stato-videoperizia.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditStatoVideoperiziaComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'stati-videoperizia',
  templateUrl: './stati-videoperizia.component.html',
  styleUrls: ['./stati-videoperizia.component.scss']
})
export class StatiVideoperiziaComponent implements OnInit {


  headingText: string = 'Stati videoperizia';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
  ];
  constructor(public statoVideoperiziaService: StatoVideoperiziaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<StatiVideoperiziaComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona uno stato di videoperizia';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (statoVideoperizia: StatoVideoperizia) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare lo stato videoperizia ${statoVideoperizia.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.statoVideoperiziaService.delete(statoVideoperizia);
          this.toast.success('Stato videoperizia eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione Stato videoperizia fallita.", "Errore!");
    }
  }



  editFunction = async (statoVideoperizia: StatoVideoperizia) => {
    try {
      let dialogRef = this.dialog.open(EditStatoVideoperiziaComponent, { data: statoVideoperizia });
      dialogRef.afterClosed().subscribe(async (data: StatoVideoperizia) => {
        if (data) {

          Object.assign(statoVideoperizia, data);

          await this.statoVideoperiziaService.edit(statoVideoperizia);

          this.toast.success('Stato videoperizia modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica stato videoperizia fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditStatoVideoperiziaComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(statoVideoperizia?: StatoVideoperizia) {
    if (statoVideoperizia) {
      try {
        await this.statoVideoperiziaService.create(statoVideoperizia)
        this.toast.success('Stato videoperizia creato!')
      }
      catch (e) {
        this.toast.error('Creazione stato videoperizia fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
